export default __webpack_public_path__ + "static/media/BowIcon.5801e4dd.svg";